export default "__VITE_ASSET__bbf8eb45__"